export default __webpack_public_path__ + "images/0x52f847356b38720b55ee18cb3e094ca11c85a192.png";